var exports = {
  "k": "xae11d333--49c722--container",
  "P": "xae11d333--49c722--cities-step",
};

module.exports = exports;
